import { useMemo } from "react";

// Soft drifting smoke haze for atmospheric depth.
export const Smoke = ({ count = 6 }) => {
  const puffs = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: 10 + Math.random() * 80,
        size: 160 + Math.random() * 220,
        delay: Math.random() * 8,
        duration: 10 + Math.random() * 8,
      })),
    [count]
  );
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" data-testid="smoke-layer">
      {puffs.map((p) => (
        <span
          key={p.id}
          className="absolute bottom-0 rounded-full"
          style={{
            left: `${p.left}%`,
            width: p.size,
            height: p.size,
            background: "radial-gradient(circle, rgba(180,255,180,0.05), rgba(120,140,120,0.03) 40%, transparent 70%)",
            filter: "blur(24px)",
            animation: `smoke-drift ${p.duration}s ease-in ${p.delay}s infinite`,
          }}
        />
      ))}
    </div>
  );
};
